<template>
  <div>
    <div class="-cta-icon"></div>
    <div class="-body">
      <div>
        <b>studio-client:</b>
        <span class="wt-version">{{ client.version }}</span
        >,
        <span>{{ clientDeployed }}</span>
      </div>
      <div>
        <b>{{ client.environment }}:</b>
        <span class="wt-version">{{ backend.version }}</span
        >,
        <span>{{ backendDeployed }}</span>
      </div>
      <div>
        {{ backend.apiUrl }}
        <span class="wt-load-balancer" title="Load Balancer">
          @{{ loadBalancer }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'SiteVersionView',

  data: function () {
    return {
      client: {
        environment: serverProfile.environment,
        version: serverProfile.version,
      },
      backend: {
        version: null,
        apiUrl: serverProfile.apiUrl,
      },
      loadBalancer: null,
    };
  },

  created: function () {
    this.backend.version = tk.siteProperties.version;
    $(document).ajaxSuccess((e, xhr) => {
      this.loadBalancer = xhr.getResponseHeader('X-Load-Balancer-Host');
    });
  },

  computed: {
    clientDeployed() {
      // eslint-disable-next-line no-unused-vars
      let now = this.$store.state.currentTime;
      now--;
      const clientBuildTime = moment(
        parseInt(serverProfile.timestamp, 36) * 1e3
      );
      return [
        clientBuildTime.calendar(),
        ' (',
        clientBuildTime.fromNow(),
        ')',
      ].join('');
    },

    backendDeployed() {
      // eslint-disable-next-line no-unused-vars
      let now = this.$store.state.currentTime;
      now--;
      const apiBuildTime = moment(
        tk.siteProperties.buildTimestamp,
        'YYYYMMDD-HHmmZ'
      );
      return [apiBuildTime.calendar(), ' (', apiBuildTime.fromNow(), ')'].join(
        ''
      );
    },
  },
};
</script>

<style lang="scss">
.wt-site-version {
  position: absolute;
  left: 4px;
  bottom: 0;
  font-size: 11px;
  color: silver;
  z-index: 10;
  &:hover {
    left: 0;
    background-color: rgba(0, 0, 0, 0.7);
    padding: 8px;
    .-cta-icon {
      display: none;
    }
    .-body {
      display: block;
      width: auto;
      height: 45px;
    }
  }
  .-cta-icon {
    width: 23px;
    height: 23px;
    display: inline-block;
    background: url('/resources/img/roughcut_i_icon.png') no-repeat;
  }
  .-body {
    width: 0;
    display: none;
  }
  .wt-version {
    color: white;
    font-weight: bold;
  }
  .wt-load-balancer {
    color: #ee0b72;
    font-weight: bold;
  }
}
</style>
